import React from 'react';
import { Button, Grid, Input, TextArea, Form } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";

import GetDate from '../../../functions/date';
import ReadCookie from '../../../functions/readcookies';
import Server from '../../../functions/server';

class Receipt extends React.Component {

    state = {
        data: [],
    }

    componentDidMount() {
        this.CustomerAndLedger();
    }

    

    CustomerAndLedger() {
        let context = this;
        $.ajax({
            type: 'POST', 
            url: Server()+'machine/receipt/getCustomerAndLedger.php',
            success: function(data) {
                try {
                    data = JSON.parse(data);
                    context.setState({ data, load: false })
                } catch (error) {
                    alert('Try Agian!!!');
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
            }
        });
    }

    submit(mode_id, mode) {
        let context = this; 
        $.ajax({
            type: 'POST', data: { mode_id, mode, id: context.props.id }, 
            url: Server()+'machine/receipt/changemode.php',
            success: function(data) {
                console.log(data);
                if (data == 1) {
                    context.setState({ load: false, openDialog: false })
                    context.props.refreshData();
                }
                else {
                    alert('Try Again!!!')
                    context.setState({ load: false })
                }
            },
            error: function(e) {
                alert('Try again!!')
            }
        });
    }

    render() {
        return (
            <div>
                <b style={{color: 'blue'}} onClick={ () => { 
                    if (!this.props.menuPermission.edit) {
                        alert('You Are Not Allow To Change Mode!!!');
                        return;
                    }
                    this.setState({ openDialog: true }) 
                    }}>{this.props.mode}</b>
                <Dialog fullWidth={true} maxWidth={'sm'} open={this.state.openDialog}
                    onClose={ () => { this.setState({ openDialog: false }) }}
                    aria-labelledby="max-width-dialog-title" >
                    <DialogTitle id="max-width-dialog-title">{'Change Mode'}</DialogTitle>
                    <DialogContent>
                        {
                            this.state.data.map((c) => {
                                if (c.type == 'Ledger') {
                                    return (
                                        <h5 style={{cursor: 'pointer'}} onClick={this.submit.bind(this, c.id, c.name)}>{c.name}</h5>
                                    ) 
                                }
                            })
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ openDialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default Receipt;
